import CioQuiz from '@constructor-io/constructorio-ui-quizzes/constructorio-ui-quizzes-bundled';
import {getCountryPath} from '../../spa/helper';
import ConstructorIOProduct from '../product';
import {getProductURL} from './url';
import {processQuizProduct} from './result';

/**
 *  Init constructor Quiz
 *
 */
export default () => {
    const quizContainer = $('#quiz-container');

    if (quizContainer.length) {
        const apiKey = quizContainer.data('apiKey');
        const quizId = quizContainer.data('quizId');
        const countryPath = getCountryPath();

        CioQuiz({
            selector: '#quiz-container',
            quizId,
            apiKey,
            callbacks: {
                /**
                 * callback on click add to cart
                 */
                onAddToCartClick: () => {
                    // do nothing
                },
                /**
                 *  On click click product tile add country prefix to url and open it
                 *
                 * @param {Object} result product result from constructor
                 */
                onQuizResultClick: result => {
                    const product = new ConstructorIOProduct(result);
                    const url = getProductURL(result.variations_map, product, countryPath);
                    window.location.href = url;
                }
            },
            resultCardOptions: {
                /**
                 *  Show price based on function manipulation
                 *
                 * @param {Object} result product data from constructor
                 * @returns {string} formatted price
                 */
                renderResultCardPriceDetails: result => {
                    const quizProduct = processQuizProduct(result);
                    return quizProduct?.priceInfo?.minPrice || '';
                }
            }
        });
    }
};
